jQuery(document).ready(function ($) {
  var searchDrawer = $('#SearchDrawer');
  var searchToggle = $('.menu-link--search-toggle');

  function searhDrawerHide() {
    //searchDrawer.hide();
    searchDrawer.css("transform","translateY(-100px)");
    $('body').removeClass('js-drawer-open');
    $('body').removeClass('js-drawer-open-top');
    $('body').removeClass('prevent-scrolling');
  }

  $(searchToggle).on('click', function () {
    $(searchDrawer).css({
      'height': '80px',
      'display': 'flex'
    });

    var $bar = $('#fsb_background');

    if ($bar.length) {
      $(searchDrawer).css({
        'top': $bar.height() + 'px'
      })
    }

    $(searchDrawer).find('input.search-form__input').focus();
    $('body').addClass('js-drawer-open js-drawer-open-top prevent-scrolling');
    searchDrawer.css("transform","translateY(0px)");
  });

  $('.search-bar__close').on('click', function () {
    searhDrawerHide();
  });

  $('.section-slider').on('click', function () {
    searhDrawerHide();
  });

});